import { render } from "./otp2.vue?vue&type=template&id=d28e0dfc&scoped=true"
import script from "./otp2.vue?vue&type=script&lang=js"
export * from "./otp2.vue?vue&type=script&lang=js"

import "./otp2.vue?vue&type=style&index=0&id=d28e0dfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d28e0dfc"]])

export default __exports__